/* ============================================================
   THE COLOUR CARTEL — PDP + COLLECTION PRICING
   Added 18 Aug 2026. Paired with assets/cc-custom.css
   Remove both lines from theme.liquid to revert.
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     Deepest volume discount, as a percentage.
     Read live from the pricing table on product pages.
     Collection cards do not render that table, so this constant
     is used there instead.

     Verified identical across the catalogue 18 Aug 2026 —
     ASColour Basic Tee, ASColour Heavy Hood, Biz Collection
     Men's Ice Tee, JB's Wear JB's Tee, ASColour Surf Cap:
       qty    0    5   10   20   50  100  200  500  1000
       disc  0%  10%  20%  25%  30%  35%  40%  45%   50%

     >>> IF THE LADDER CHANGES IN THE APP, CHANGE THIS. <<<
     ---------------------------------------------------------- */
  var MAX_VOLUME_DISCOUNT = 50;

  var cache = {};
  var pending = {};

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* /collections/x/products.json returns decimal strings ("18.90")
     /products/handle.js returns integer cents (1890).
     Getting this wrong is a 100x error. */
  function pricesInCents(p) {
    return p.variants.map(function (v) {
      return typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100);
    }).filter(function (n) { return n > 0; });
  }

  /* Products that must NOT get a per-unit "each" range.
     Four layers, each catches something the others miss. Without
     it, pack products render "$217.60 - $14,500.00 each". */
  function skipReason(p) {
    var opts = (p.options || []).map(function (o) {
      return (typeof o === 'string' ? o : (o.name || '')).toLowerCase();
    });
    if ((p.product_type || p.type) === 'Bundle') return 'type=Bundle';
    if (opts.indexOf('quantity') !== -1)         return 'Quantity option';
    if (/^\s*\d+\s*x\s/i.test(p.title))          return 'Nx title';
    var pr = pricesInCents(p);
    if (!pr.length)                              return 'no price';
    if (Math.max.apply(null, pr) / Math.min.apply(null, pr) > 3) return 'variant spread >3x';
    return null;
  }

  function maxDiscountFromTable(host) {
    if (!host) return 0;
    var d = Array.prototype.slice.call(host.querySelectorAll('table tr'), 1).map(function (tr) {
      var cell = tr.children[1];
      var v = cell ? parseFloat(cell.textContent.replace(/[^0-9.]/g, '')) : NaN;
      return isNaN(v) ? 0 : v;
    });
    return d.length ? Math.max.apply(null, d) : 0;
  }

  /* ---------- PRODUCT PAGE ---------- */
  function buildProductPrice() {
    var mount = document.querySelector('.builder-price');
    var host  = document.querySelector('bulk-discount-faded-out');
    /* .builder-price only exists on decorable garments, so design
       and signage products never reach this code. */
    if (!mount || !host || document.querySelector('.cc-price')) return;

    fetch(window.location.pathname + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        if (skipReason(p)) return;

        var pr   = pricesInCents(p);
        var lo   = Math.min.apply(null, pr);
        var hi   = Math.max.apply(null, pr);
        var disc = maxDiscountFromTable(host);
        var low  = Math.round(lo * (1 - disc / 100));

        var el = document.createElement('div');
        el.className = 'cc-price';
        el.innerHTML =
          '<span class="cc-price__range">' +
          (low < hi ? money(low) + ' - ' + money(hi) : money(hi)) +
          ' each</span><span class="cc-price__decoration">+ Decoration</span>';
        mount.prepend(el);
        mount.classList.add('cc-price-ready');
      });
  }

  /* Toggle labels + class swap. Dropping btn--underline is the
     point: its rules override the padding and squash the button
     to 22px tall. */
  function fixToggles() {
    var labels = [
      ['.bulk-discount-faded-out__expand-text', 'Preview Volume Pricing'],
      ['.bulk-discount-faded-out__hide-text',   'Hide Volume Pricing'],
      ['.bulk-discount-faded-out__hide',        'Hide Volume Pricing']
    ];
    labels.forEach(function (pair) {
      var el = document.querySelector(pair[0]);
      if (el) el.textContent = pair[1];
    });

    ['bulk-discount-faded-out__expand', 'bulk-discount-faded-out__hide'].forEach(function (k) {
      Array.prototype.forEach.call(document.querySelectorAll('.' + k), function (b) {
        b.classList.remove('btn', 'btn--underline', 'ml-auto');
        b.classList.add('button', 'button--small', 'cc-preview-btn');
      });
    });
  }

  /* The theme line reads "Tax included. Shipping and GST
     calculated at checkout." — self-contradictory. */
  function fixTaxLine() {
    var el = document.querySelector('.product__tax');
    if (el) el.innerHTML = 'GST included. <a href="/policies/shipping-policy">Shipping</a> calculated at checkout.';
  }

  /* ---------- COLLECTION CARDS ---------- */
  function applyToCard(card, product) {
    var info = card.querySelector('.product-card__info');
    if (!info) return;

    /* "Buy Custom From" marks a builder product, but is NOT
       sufficient alone — three "10x ... Bundle" products carry it
       too, which is why skipReason still runs. */
    var strong = Array.prototype.slice.call(info.querySelectorAll('strong')).filter(function (e) {
      return /Buy Custom From/i.test(e.textContent);
    })[0];

    var gstNote = Array.prototype.slice.call(info.querySelectorAll('div')).filter(function (e) {
      return e.children.length === 0 && /excl\.? ?GST/i.test(e.textContent);
    })[0];

    if (!strong)                       { if (gstNote) gstNote.remove(); return; }
    if (!product || skipReason(product)) { if (gstNote) gstNote.remove(); return; }

    var pr  = pricesInCents(product);
    var lo  = Math.min.apply(null, pr);
    var hi  = Math.max.apply(null, pr);
    var low = Math.round(lo * (1 - MAX_VOLUME_DISCOUNT / 100));

    strong.textContent = (low < hi ? money(low) + ' - ' + money(hi) : money(hi)) + ' each';
    strong.classList.add('cc-card-price');

    if (gstNote) {
      gstNote.textContent = '+ Decoration';
      gstNote.classList.add('cc-card-decoration');
    } else {
      var d = document.createElement('div');
      d.className = 'cc-card-decoration';
      d.textContent = '+ Decoration';
      strong.parentElement.appendChild(d);
    }
  }

  /* One request covers a whole collection. */
  function loadCollection() {
    var m = window.location.pathname.match(/\/collections\/([^\/]+)/);
    if (!m) return Promise.resolve();
    return fetch('/collections/' + m[1] + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.products) j.products.forEach(function (p) { cache[p.handle] = p; });
      })
      .catch(function () {});
  }

  /* Fallback for cards outside the collection — mega-menu promos,
     cross-sells, search. Cached and deduped. */
  function getProduct(handle) {
    if (cache[handle])   return Promise.resolve(cache[handle]);
    if (pending[handle]) return pending[handle];
    pending[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cache[handle] = p; return p; })
      .catch(function () { return null; });
    return pending[handle];
  }

  function processCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.product-card'))
      .filter(function (c) { return !c.dataset.ccDone; });
    if (!cards.length) return Promise.resolve();

    return Promise.all(cards.map(function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) { card.dataset.ccDone = '1'; return null; }
      var handle = a.getAttribute('href').split('/products/')[1].split('?')[0];
      return getProduct(handle).then(function (p) {
        applyToCard(card, p);
        card.dataset.ccDone = '1';
      });
    }));
  }

  /* Grids re-render on AJAX filter/sort and pagination. */
  function watch() {
    var target = document.querySelector('#main, main, body');
    if (!target || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; processCards(); }, 150);
    }).observe(target, { childList: true, subtree: true });
  }

  function init() {
    buildProductPrice();
    fixToggles();
    fixTaxLine();
    loadCollection().then(processCards).then(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
